import { gql, useLazyQuery, useQuery } from "@apollo/client";

export const moduleCatalogItemByIdVersionQuery = gql`
  query CatalogItemById($id: ID!) {
    catalogItemByVersionedId(versionedId: $id) {
      content {
        id
      }
      outline
      contentFiles {
        name
        id
        version
        xAPIOutline
      }
    }
  }
`;

export const useGetModuleCatalogItemByIdVersion = () => {
  return useLazyQuery(moduleCatalogItemByIdVersionQuery);
};
